var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"iframeRef",staticStyle:{"border":"1px solid #e9eaed"},attrs:{"src":_vm.$data.pathPrefix + '/ru/page/67036?' + _vm.$data.recordIdParam,"width":"100%","height":"1300px"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }